import { pageContext } from "../interfaces/context"

export function chaturbateLogo(): string {
    return pageContext.current?.current_logo ?? `${STATIC_URL_ROOT}images/logo.svg`
}
